<script type="text/javascript">
    import { defineAsyncComponent } from 'vue';

    export default {
        UiTable: defineAsyncComponent(() => import(/* webpackChunkName: "ui-table" */'@/components/UI/Table/Table.vue')),
        TableHead: defineAsyncComponent(() => import(/* webpackChunkName: "ui-table" */'@/components/UI/Table/Head.vue')),
        TableBody: defineAsyncComponent(() => import(/* webpackChunkName: "ui-table" */'@/components/UI/Table/Body.vue')),
        TableFoot: defineAsyncComponent(() => import(/* webpackChunkName: "ui-table" */'@/components/UI/Table/Foot.vue')),
        TableCaption: defineAsyncComponent(() => import(/* webpackChunkName: "ui-table" */'@/components/UI/Table/Caption.vue')),
        TableRow: defineAsyncComponent(() => import(/* webpackChunkName: "ui-table" */'@/components/UI/Table/Row.vue')),
        TableHeadCell: defineAsyncComponent(() => import(/* webpackChunkName: "ui-table" */'@/components/UI/Table/HeadCell.vue')),
        TableCell: defineAsyncComponent(() => import(/* webpackChunkName: "ui-table" */'@/components/UI/Table/Cell.vue')),
    }
</script>